<template>
   <div class='o-and-c'>
      <process-header :step="4"/>
      <div class="body">
         <div class='step-title'>Opportunties & Challenges</div>
         <div class='tables'>
            <div
               v-for="[name, table] in Object.entries(tables)"
               :key="name"
               >
               <div class="add-button-wrapper">
                  <add-button @click="showCreateForm(name)">Add {{table.title}}</add-button>
               </div>
               <el-table :data="table.data">
                  <el-table-column label="Actions" fixed width="100">
                     <template slot-scope="scope">
                        <el-button
                           @click="handleEdit(scope.$index, scope.row, name)"
                           size="mini"
                           icon="el-icon-edit"
                           style="margin: 3px;"
                           circle
                           content="Edit"
                           v-tippy
                        />
                        <el-button
                           @click="handleDelete(scope.$index, scope.row, name)"
                           size="mini"
                           icon="el-icon-delete"
                           content="Delete"
                           v-tippy
                           circle
                        />
                     </template>
                  </el-table-column>
                  <el-table-column
                     v-for="{label, prop, width} in table.columns"
                     :key="prop"
                     :prop="prop"
                     :width="width"
                     :label="label"
                  />
               </el-table>
            </div>
         </div>
         <back-and-continue
            :back-route="{name: 'vision-mission'}"
            :next-route="{name: 'activities'}"
         />
      </div>
      <common-dialog-form
         :visible="showForm"
         :title="formTitle"
         @close="showForm=false"
         @submit="handleFormSubmit"
         >
         <input-field
            label="Description"
            type="textarea"
            v-model="form.description"
            :errors="errors.description"
            required
         />
      </common-dialog-form>
   </div>
</template>

<script>
import ProcessHeader from "../Header";
import { Table, TableColumn, Button } from 'element-ui';
import AddButton from '../../../../molecules/Home/Plan/AddButton';
import BackAndContinue from '../../../../molecules/Home/Plan/Back&Continue'
import InputField from '../../../../molecules/Login/InputField';
import { fetchWithAuthToken, postWithAuthToken } from '../../../../../axios';
import CommonDialogForm from '../../../../organisms/Home/CommonDialogForm';
import { getDefaultErrors,updateProps } from '../../../../../js/form-helpers';
import { showError, showSuccess, showLoading, hideLoading } from '../../../../../js/ui-helpers';

const getDefaultForm = (data) => ({
   id: null,
   plan_id: null,
   description: null,
   tableKey: null,
   method: 'post',
   ...data
})

export default {
   name: "opp-and-challenges",
   components: {
      ProcessHeader,
      'el-table': Table,
      'el-table-column': TableColumn,
      'el-button': Button,
      BackAndContinue,
      AddButton,
      CommonDialogForm,
      InputField,
   },
   data()
   {
      return {
         form: getDefaultForm(),
         errors: getDefaultErrors(getDefaultForm()),
         tables: {
            opportunities: {
               title: "Opportunity",
               data: [],
               columns: [
                  {label: "Opportunity", prop: "description", },
               ]
            },
            challenges: {
               title: "Challenge",
               data: [],
               columns: [
                  {label: "Challenges", prop: "description", },
               ]
            },
         },
         showForm: false,
      };
   },
   computed: {
      planId()
      {
         return this.$route.params.id;
      },
      formTitle()
      {
         return this.tables[this.form.tableKey] && this.tables[this.form.tableKey].title
      },
   },
   async created()
   {
      this.loadData();
   },
   methods: {
      loadData() {
         Object.keys(this.tables).forEach( tableKey =>
         {
            fetchWithAuthToken(this.getApiUrl(tableKey))
            .then(({data}) => this.tables[tableKey].data=data)
         });
      },
      resetErrors()
      {
         updateProps(this.errors, getDefaultErrors(this.form));
      },
      getApiUrl(tableKey)
      {
         if (tableKey==='opportunities') return `api/plan/${this.planId}/opportunities/`;
         if (tableKey==='challenges') return `api/plan/${this.planId}/challenges/`;
         console.error(`Invalid tableKey ${tableKey}`);
         console.trace();
      },
      showCreateForm(tableKey)
      {
         this.form = getDefaultForm({tableKey, method: 'post'});
         this.showForm = true;
      },
      handleEdit(index, row, tableKey)
      {
         this.form = getDefaultForm({tableKey, method: 'put', ...row});
         this.showForm = true;
      },
      handleDelete(index, row, tableKey)
      {
         showLoading();
         postWithAuthToken(`${this.getApiUrl(tableKey)}${row.id}`, {}, {method: 'delete'})
         .then(() =>
         {
            this.loadData();
            showSuccess('Opportunity & Challenges', `Successfully deleted`);
         })
         .catch(() =>
         {
            showError('Opportunity & Challenges', `Failed deleting`);
         })
         .finally(() => hideLoading());
      },
      handleFormSubmit()
      {
         const method = this.form.method;
         const apiUrl = `${this.getApiUrl(this.form.tableKey)}${method==='post' ? '' : this.form.id}`;
         showLoading();
         postWithAuthToken(apiUrl, this.form, {method})
         .then(() =>
         {
            this.loadData();
            showSuccess('Opportunity & Challenges', `Successfully ${method==='post' ? 'added' : 'edited'} ${this.formTitle.toLowerCase()}`);
         })
         .catch(() =>
         {
            showError('Opportunity & Challenges', `Failed ${method==='post' ? 'adding' : 'editing'} ${this.formTitle.toLowerCase()}`);
         })
         .finally(() =>
         {
            this.form = getDefaultForm();
            this.showForm = false;
            hideLoading();
         });
      }
   },
};
</script>

<style lang="scss" scoped>
.o-and-c {
   font-family: $primary-font;
   color: $font-color;
   .step-title {
      font-family: $secondary-font;
      font-weight: 500;
      font-size: 1.05em;
      margin-bottom: 0.5em;
   }
   > .body {
      padding: 0.6em;
   }
   .add-button-wrapper {
      width: 100%;
      padding: 0.5em;
      > * {
         margin-left: auto;
      }
   }
   .tables {
      display: flex;
      flex-wrap: wrap;
      > * {
         flex: 1 0 350px;
         margin: 0 1px;
         border-right: solid 1px rgba(black, 0.03);
         border-left: solid 1px rgba(black, 0.03);
      }
   }

   .btn-group {
      display: flex;
      margin: 0 0.3em;
      > * {
         margin-right: 0.3em;
         a {
            color:inherit;
         }
         &:last-child {
            margin-right: 0;
         }
      }
   }
}
</style>
